import React from 'react'
import { Form, Message } from 'semantic-ui-react'

const numericInputRegex = /^(?:[0-9]\d*)?$/

const quantityDefs = [
  { key: 'L20', label: '20L', placeholder: '0' },
  { key: 'L30', label: '30L', placeholder: '0' },
  { key: 'L50', label: '50L', placeholder: '0' },
  { key: 'G9', label: '9G', placeholder: '0' },
]

const handleQtyBeforeInput = e => {
  const ev = e.nativeEvent
  if (ev.isComposing) return
  const { value, selectionStart, selectionEnd } = e.currentTarget
  const selStart = selectionStart ?? value.length
  const selEnd = selectionEnd ?? selStart
  const insertText = ev.data ?? ''
  const nextValue = value.slice(0, selStart) + insertText + value.slice(selEnd)
  const isDelete = ev.inputType?.startsWith('delete')
  const matchesRegex = numericInputRegex.test(nextValue)
  if (!matchesRegex && !(isDelete && nextValue === '')) e.preventDefault()
}

const handleQtyPaste = e => {
  const text = e.clipboardData.getData('text')
  const { value, selectionStart, selectionEnd } = e.currentTarget
  const selStart = selectionStart ?? value.length
  const selEnd = selectionEnd ?? selStart
  const nextValue = value.slice(0, selStart) + text + value.slice(selEnd)
  if (!numericInputRegex.test(nextValue)) e.preventDefault()
}

function KegCollectionKegQuantitiesInputs(props) {
  const {
    formValues,
    onChange,
    isDisabled,
    validationErrors,
    showValidationErrors = true,
    focusFirstInput = false,
  } = props
  const firstInputRef = React.useRef(null)

  React.useEffect(() => {
    if (focusFirstInput && !isDisabled) {
      firstInputRef.current?.focus()
    }
  }, [focusFirstInput, isDisabled])

  return (
    <>
      <Form.Group widths="equal">
        {quantityDefs.map(({ key, label, placeholder }, index) => (
          <Form.Field
            key={key}
            error={showValidationErrors && !!validationErrors.kcRequestItemQtyObjectSet}
          >
            <label htmlFor={key}>{label}</label>
            <input
              ref={index === 0 ? firstInputRef : undefined}
              type="number"
              id={key}
              name={key}
              value={formValues[key]}
              onChange={onChange}
              onBeforeInput={handleQtyBeforeInput}
              onPaste={handleQtyPaste}
              step={1}
              min={0}
              max={999}
              disabled={isDisabled}
              placeholder={placeholder}
              style={{ textAlign: 'center' }}
            />
          </Form.Field>
        ))}
      </Form.Group>
      {showValidationErrors && validationErrors.kcRequestItemQtyObjectSet && (
        <Message negative size="small" content={validationErrors.kcRequestItemQtyObjectSet} />
      )}
    </>
  )
}

export default React.memo(KegCollectionKegQuantitiesInputs)
